/* Ceryn "Bloom" loader: lotus veil on page changes and lotus placeholders while images load. */
(() => {
  if (window.crLoader || (window.Shopify && window.Shopify.designMode)) return;

  /* Image placeholders: containers show the lotus until their first image has loaded. */
  const root = document.documentElement;
  const done = (img) => img.classList.add('cr-in');
  document.querySelectorAll('img').forEach((img) => { if (img.complete) img.classList.add('cr-in', 'cr-c'); });
  root.classList.add('cr-imgs');
  document.addEventListener('load', (e) => { if (e.target.tagName === 'IMG') done(e.target); }, true);
  document.addEventListener('error', (e) => { if (e.target.tagName === 'IMG') done(e.target); }, true);

  /* Page-change veil */
  const veil = document.getElementById('cr-veil');
  if (!veil) return;
  const SAFETY = 10000;
  let safety = 0;
  const hide = () => {
    clearTimeout(safety);
    veil.classList.remove('is-on', 'is-boot');
  };
  const show = () => {
    try { sessionStorage.setItem('cr-nav', String(Date.now())); } catch (e) {}
    veil.style.setProperty('--crl-t', '0ms');
    veil.classList.remove('is-boot');
    veil.classList.add('is-on');
    clearTimeout(safety);
    safety = setTimeout(hide, SAFETY);
  };
  window.crLoader = { show, hide };

  const leavesPage = (a) => {
    if ((a.target && a.target !== '_self') || a.hasAttribute('download') || a.closest('[data-no-loader]')) return false;
    const href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript|whatsapp):/i.test(href)) return false;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return false;
    return !(url.pathname === location.pathname && url.search === location.search);
  };

  // Deferred so handlers that call preventDefault (cart drawer, quick add, filters) run first.
  document.addEventListener('click', (e) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    if (a) setTimeout(() => { if (!e.defaultPrevented && leavesPage(a)) show(); }, 0);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const target = form.getAttribute('target');
    setTimeout(() => {
      if (!e.defaultPrevented && (!target || target === '_self') && !form.closest('[data-no-loader]')) show();
    }, 0);
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) hide(); });
})();
